/** biome-ignore-all lint/suspicious/noAlert: sandbox testing */

import { toast } from 'sonner';

import { Button } from '@/shadcn/button';
import { Checkbox } from '@/shadcn/checkbox';

import { diffViewerStory } from '@/components/monaco/diffViewer/diffViewer.story';

export type StoryDeclaration = {
  variants: Record<string, React.FC>;
  defaultVariant?: string;
};

type SandboxMapping = Record<string, StoryDeclaration>;

export const sandboxMapping = {
  DiffViewer: diffViewerStory,
  Button: {
    variants: {
      Basic: () => (
        <Button onClick={() => toast.success('Button clicked')}>
          Click me
        </Button>
      ),
      Disabled: () => (
        <Button disabled onClick={() => toast.success('Button clicked')}>
          Disabled button
        </Button>
      ),
      Ghost: () => (
        <Button onClick={() => toast.success('Button clicked')} variant="ghost">
          Ghost button
        </Button>
      ),
      Link: () => (
        <Button onClick={() => toast.success('Button clicked')} variant="link">
          Link button
        </Button>
      ),
      Secondary: () => (
        <Button
          onClick={() => toast.success('Button clicked')}
          variant="secondary"
        >
          Secondary button
        </Button>
      ),
      GhostSubtle: () => (
        <Button
          onClick={() => toast.success('Button clicked')}
          variant="ghostSubtle"
        >
          Ghost subtle button
        </Button>
      ),
      GhostDestructive: () => (
        <Button
          onClick={() => toast.success('Button clicked')}
          variant="ghostDestructive"
        >
          Ghost destructive button
        </Button>
      ),
      GhostDestructiveSubtle: () => (
        <Button
          onClick={() => toast.success('Button clicked')}
          variant="ghostDestructiveSubtle"
        >
          Ghost destructive subtle button
        </Button>
      ),
      Outline: () => (
        <Button
          onClick={() => toast.success('Button clicked')}
          variant="outline"
        >
          Outline button
        </Button>
      ),
      OutlinePrimary: () => (
        <Button
          onClick={() => toast.success('Button clicked')}
          variant="outlinePrimary"
        >
          Outline primary button
        </Button>
      ),
      PushtextActive: () => (
        <Button
          active={true}
          onClick={() => toast.success('Button clicked')}
          variant="pushtext"
        >
          Pushtext button active
        </Button>
      ),
      PushtextNotActive: () => (
        <Button
          active={false}
          onClick={() => toast.success('Button clicked')}
          variant="pushtext"
        >
          Pushtext button not active
        </Button>
      ),
      PushtextMuted: () => (
        <Button
          onClick={() => toast.success('Button clicked')}
          variant="pushtextMuted"
        >
          Pushtext muted button
        </Button>
      )
    },
    defaultVariant: 'Basic'
  },
  Checkbox: {
    variants: {
      Basic: () => (
        <Checkbox
          checked={false}
          onCheckedChange={(checked: boolean) =>
            toast.success(`Checkbox changed to ${checked}`)
          }
        />
      )
    }
  }
} as const satisfies SandboxMapping;
